import { useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Please enter your email.");
    setLoading(true);
    try {
      await api.post("/newsletter", { email, name: name || undefined });
      toast.success("You're in. Welcome to the RBICA letter.");
      setEmail("");
      setName("");
    } catch (err) {
      toast.error("Could not subscribe. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      data-testid="newsletter-section"
      className="relative py-20 md:py-24 bg-[#E8F0F8]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <div className="text-xs tracking-[0.3em] uppercase text-[#1D4E89] font-medium mb-5">
          The RBICA Letter
        </div>
        <h3 className="font-serif text-3xl md:text-4xl text-[#0B2B40] tracking-tight font-light leading-tight">
          One thoughtful note a month.{" "}
          <span className="italic">No noise. No selling.</span>
        </h3>
        <form
          data-testid="newsletter-form"
          onSubmit={submit}
          className="mt-10 flex flex-col sm:flex-row items-stretch gap-3 max-w-xl mx-auto"
        >
          <input
            data-testid="newsletter-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your name (optional)"
            className="input-underline bg-white px-4"
          />
          <input
            data-testid="newsletter-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="input-underline bg-white px-4"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit-button"
            className="bg-[#0B2B40] text-white hover:bg-[#1D4E89] disabled:opacity-60 px-7 py-3 text-sm font-medium tracking-wide transition-colors duration-300 whitespace-nowrap"
          >
            {loading ? "..." : "Subscribe"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
